import { useQuery } from "react-query";
import { getFromLocalStorage, setToLocalStorage, removeAllFromLocalStorage } from '../utils/Helpers'

import {axiosInstances} from './index'

export const registerWithPhoneNumber = async (formData) => {
  setToLocalStorage('userData', formData)
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post("/auth/send-otp", {phoneNumber: formData.phoneNumber}).then((response) =>{
      resolve(response.data)
    }).catch((err) => {
      let error =  {...err}
      reject(error.response)

    })
  })
};

export const loginWithPhoneNumber = async (number) => {
	let data = number
  let form = getFromLocalStorage('userData')
  if (!data) {
    data = form.phoneNumber
  }else{
    setToLocalStorage('userData', {...form , phoneNumber : data})
  }

  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post("/auth/send-otp", {phoneNumber: data}).then((response) =>{
      let form2 = getFromLocalStorage('userData')
      resolve(response.data)
    }).catch((err) => {
      let error =  {...err}
      reject(error.response)
    })
  })
};

export const verifyOTP = (otp) => {
	if (otp) {
    let form = getFromLocalStorage('userData')
    return new Promise(async(resolve, reject) => {
      await axiosInstances.api.post("/auth/verify-otp", {phoneNumber: form.phoneNumber, otp: otp}).then(async (response) =>{
      	await setToLocalStorage('token',response.data.sessionId)
        await setToLocalStorage('userAuthData',response.data)
        
        if (response.data.newAccountCreated) {
          await updateUserProfile(response.data.userId);
        }
        resolve(response.data)
      }).catch((err) => {
        let error =  {...err}
        reject(error.response)
      })
    })
	}
}

export const updateUserProfile = (data) => {
  if(Object.keys(data).length){
    return new Promise(async(resolve, reject) => {
      await axiosInstances.api.post("/user/profile", data).then((response) =>{
      	setToLocalStorage('userData', response.data)
        resolve(response.data)
      }).catch((err) => {
        let error =  {...err}
        reject(error.response.data.message)
      })
    })
  }
}

export const getCaptcha = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get("/gstn/captcha", {}).then((response) =>{
      resolve(response.data)
    })
  })
}

export const getActiveGstinDetail = (data) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post("/gstn/pan/gstin-details", data).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const setConsent = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post("/user/consent", {consent: true}).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getBussinessDetail = (data) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post("/business", data).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getGstinDetail = (data) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get("/business", data).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getOtpWithUsername = (entityId, username) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/gst/${entityId}/username`, {"username": username}).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const sendOtpWithEntityId = (entityId) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/gst/${entityId}/otp`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const confirmOtpWithEntityId = (entityId, otp) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/gst/${entityId}/otp`, {otp: otp}).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getDownloadStatus = (ids) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/gst/pull/statuses?${ids}`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const downloadGstin = (id) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/gst/${id}/pull`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const computeCredits = (id) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/credit-eligibility/compute`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getComputeCreditsStatus = (id) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/credit-eligibility/compute/status`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getUserStatus = (id) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/user/state`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getLenderSessionUrl = (id) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/lender/onboarding/session`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getVerificationStatus = (token) => {
  return new Promise(async(resolve, reject) => {
    let url = `/gst/auth`;
    if (token) {
      url = `/gst/auth?token=${token}`;
    }
    await axiosInstances.api.get(url).then(async (response) =>{
      await setToLocalStorage('token', {step: 'verification'});
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const saveVerificationStatus = (id) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/gst/pre-check?passed=true`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getOtp = (phone) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/user/phone-number/send-otp`, {phoneNumber: phone}).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const confirmOtp = (phone, otp) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/user/phone-number/verify-otp`, {phoneNumber: phone, otp: otp}).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getBureauStatus = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/credit-eligibility/bureau/status`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const updateBureauMobile = (phone) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/credit-eligibility/bureau/mobileNo`, {mobileNo: phone}).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getOfferDetails = (phone) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/credit-eligibility/offer-details`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const logout = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/auth/logout`).then((response) =>{
    	removeAllFromLocalStorage();
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getUserDetail = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/user/profile`).then((response) =>{
    	setToLocalStorage('userData', response.data)
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const linkPartner = (token) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/user/link/partner?token=${token}`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getPartnerData = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/user/partner`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const getProfileData = () => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.get(`/loan/profile`).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}

export const updateUserState = (state, id) => {
  return new Promise(async(resolve, reject) => {
    await axiosInstances.api.post(`/user/state`, {userState: state, userId : id}).then((response) =>{
      resolve(response.data)
    }).catch(error => {
    	reject(error.response.data)
    })
  })
}
